





























import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component({
    name: 'EmailVerification',
})
export default class EmailVerification extends Vue {
    protected state: string | null = null;
    @Action('user/confirmUser') private confirmUser!: (token: string) => Promise<unknown>;

    protected async created() {
        if (!this.$route.params.token) {
            this.navigateToLogin();
            return;
        }
        const data = this.confirmUser(this.$route.params.token)
            .then(() => {
                this.state = 'success';
            }).catch((e: Error) => {
                this.state = 'error';
            });
    }

    protected navigateToLogin() {
        this.$router.push({name: 'Login'});
    }
}
